// IMPORT PACKAGE REFERENCES
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem} from 'reactstrap';

//COMPONENT

class PlanogramItem extends React.Component {
    
    constructor(props) {
        super(props);

        this.state = {
            dropdownOpen: false,
        };

        this.toggleDropDown = this.toggleDropDown.bind(this);
        this.deletePlanogram = this.deletePlanogram.bind(this);
    }

    toggleDropDown() {
        this.setState(prevState => ({
            dropdownOpen: !prevState.dropdownOpen
        }));
    }

    deletePlanogram(){
        this.props.deletePlanogram(this.props.planogram.id);
    }

    render() {
        return (
            <div className={'planogram-item'}>

                <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggleDropDown}>
                    <div className='planogram-more'> 
                        <DropdownToggle className="hidden-dropdown" >
                        </DropdownToggle>
                        <img className='planogram-more-image noselect' src={require('../../../../images/dotdotdot.png')} />
                    </div>

                    <DropdownMenu>
                        <DropdownItem onClick={this.deletePlanogram}>Delete</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
                
                <div className={'planogram-details'}>
                    <div className={'planogram-details-image-container'}>
                        <img className='planogram-image noselect' src={require('../../../../images/segments/' + this.props.planogram.image)} />
                    </div>
                    <div className='planogram-title'> {this.props.planogram.name} </div>
                </div>
                
                
            </div>
        );
    }
}

PlanogramItem.propTypes = {
    history: PropTypes.object.isRequired,
    planogram: PropTypes.object.isRequired,
    deletePlanogram: PropTypes.func.isRequired
};

const hoc = withRouter(PlanogramItem);

// EXPORT COMPONENT
export { hoc as PlanogramItem };


// WEBPACK FOOTER //
// ./src/components/pages/Equipment/Details/PlanogramItem.js